import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledMatchedTransactionDetails = styled.div`
  ${bordersStyles.default};
  
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
`;

const StyledMatchedTransactionDetailsSpace = styled(Space)`
  ${typographyStyles.footnote.description};
  
  color: ${props => props.theme.colors.neutral_10};
  width: unset !important;
  
  .edit-btn {
    svg {
      height: 16px;
      width: 16px;
    }
  }
`;

export {
  StyledMatchedTransactionDetails,
  StyledMatchedTransactionDetailsSpace,
}